<app-help-page mainVideo="notification-destinations"
               [tutorials]="['notification-destinations', 'daily-notifications', 'breakdown-alert', 'real-time-notifications', 'quick-start']"
               [videos]="['notification-destinations', 'daily-notifications', 'ga-real-time-notifications']"></app-help-page>
